import { Proposta } from "@/interfaces/Proposta"
import { api } from "./api"

// Endpoint Proposta
async function criarProposta(data: Proposta) {
    return await api.post(`/proposta/cria`, data)
}

async function atualizarProposta(id: string, data: any) {
    return await api.patch(`/proposta/atualizar/${id}`, data)
}

async function listarProposta(id: string) {
    const resposta = await api.get(`/proposta/listar/${id}`)
    console.log("Resposta da listagem de proposta:", resposta.data)
    return resposta.data
}

async function buscarProposta(id: string) {
    const resposta = await api.get(`/proposta/buscar/${id}`)
    console.log("Resposta da busca de proposta:", resposta.data)
    return resposta.data
}

async function deletarProposta(id: string) {
    return await api.patch(`/proposta/deletar/${id}`)
}

async function gerarLinkProposta(atendimento_id: number) {
    const resposta = await api.get(`/proposta/gerarLink/${atendimento_id}`);
    return resposta.data;
}

async function atualizarEstadoPagamento(idProposta: string, data: { estado_pagamento: string, pagamentoTipo: string }) {
    const resposta = await api.patch(`/proposta/alterarEstadoPagamento/${idProposta}`, data);
    return resposta.data;
} 

// Endpoint imagem proposta
async function criarImagemProposta(id: string, file: File[]) {
    const dados = new FormData()

    if (!file || file.length === 0) return

    file?.forEach(file =>
        dados.append('image', file)
    )

    return await api.post(`/propostaImagem/imagem/${id}`, dados, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

async function listarImagemProposta(proposta_id: string) {
    return await api.get(`/propostaImagem/listarImagens/${proposta_id}`)
}

async function removerImagemProposta(id: string) {
    return await api.delete(`/propostaImagem/removerImagemProposta/${id}`)
}

// Endpoint proposta financeira
async function criarPropostaFinanceira(data: any) {
    return await api.post(`/propostaFinanceira/criar`, data)
}

async function listarPropostaFinanceira(proposta_id: string) {
    const response = await api.get(`/propostaFinanceira/listar/${proposta_id}`)
    console.log("Resposta da listagem de proposta financeira:", response.data)
    return response
}

async function atualizarPropostaFinanceira(id: string, data: any) {
    return await api.patch(`/propostaFinanceira/atualizar/${id}`, data)
}

async function buscarPropostaFinanceira(id: string) {
    const resposta = await api.get(`/propostaFinanceira/buscar/${id}`)
    console.log("Resposta da busca de proposta financeira:", resposta.data)
    return resposta.data
}

async function deletarPropostaFinanceira(id: string) {
    return await api.delete(`/propostaFinanceira/${id}`)
}

// Endpoint condicao pagamento
async function criarCondicaoPagamento(data: any) {
    const resposta = await api.post(`/condicaoPagamento/criar`, data)
    return resposta.data.id
}

async function atualizarCondicaoPagamento(id: string, data: any) {
    const resposta = await api.patch(`/condicaoPagamento/atualizar/${id}`, data)
    return resposta.data
}

async function buscarPorCondicaoPagamento(id_proposta_financeira: string) {
    const resposta = await api.get(`/condicaoPagamento/buscar/${id_proposta_financeira}`)
    console.log("Resposta da busca por condição de pagamento:", resposta.data)
    return resposta.data
}

// Endpoint parcela
async function criarParcela(data: any) {
    const resposta = await api.post(`/parcela/criar`, data)
    return resposta.data
}

async function buscarParcelas(condicao_pagamento_id: string) {
    const resposta = await api.get(`/parcela/buscar/${condicao_pagamento_id}`)
    return resposta.data

}

async function atualizarParcela(data: any) {
    const resposta = await api.patch(`/parcela/atualizar/`, data)
    return resposta.data
}

async function ativarProposta(id: string, condicaoPagamentoId: string) {
    return await api.patch(`/proposta/ativar/${id}/${condicaoPagamentoId}`)
}

async function getPropostaAtiva(atendimento_id: string) {
    return await api.get(`/proposta/ativa/${atendimento_id}`)
}

async function enviarPropostaParaCliente(atendimento_id: string, data: { resumo: string, proposta_id: number}) {
    return await api.post(`/proposta/enviarParaCliente`, { atendimento_id, data });
}

async function buscarPropostaPorAtendimento(atendimento_id: number) {
    return await api.get(`/proposta/propostaPorAtendimento/${atendimento_id}`)
}

export const propostaApi = {
    criarProposta,
    atualizarProposta,
    listarProposta,
    buscarProposta,
    deletarProposta,
    gerarLinkProposta,
    atualizarEstadoPagamento,
    criarImagemProposta,
    listarImagemProposta,
    removerImagemProposta,
    listarPropostaFinanceira,
    atualizarPropostaFinanceira,
    criarPropostaFinanceira,
    buscarPropostaFinanceira,
    deletarPropostaFinanceira,
    criarCondicaoPagamento,
    buscarPorCondicaoPagamento,
    criarParcela,
    buscarParcelas,
    atualizarCondicaoPagamento,
    atualizarParcela,
    ativarProposta,
    getPropostaAtiva,
    enviarPropostaParaCliente,
    buscarPropostaPorAtendimento
}



